import { render, staticRenderFns } from "./complaintWorkAction.vue?vue&type=template&id=a0c44c38&"
import script from "./complaintWorkAction.vue?vue&type=script&lang=js&"
export * from "./complaintWorkAction.vue?vue&type=script&lang=js&"
import style0 from "./complaintWorkAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports